import * as React from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import "./footer.css";

export default function Footerservicesdesktop() {
  return (
    <Box className="Footermenumainbox">
      <nav aria-label="main mailbox folders">
        <List>

          <ListItem disablePadding className='footerlistitemmenuname' >
            <ListItemButton>
              <ListItemIcon>
              </ListItemIcon>
              <ListItemText primary="Services" />
            </ListItemButton>
          </ListItem>
        </List>
      </nav>
      <Divider />
      <nav aria-label="secondary mailbox folders">
        <List>
          <ListItem disablePadding>
            <ListItemButton component="a" href="#wedding-websites">
              <ListItemText primary="Wedding Websites" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton component="a" href="#wedding-invitations">
              <ListItemText primary="Wedding Invitations" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton component="a" href="#wedding-video">
              <ListItemText primary="Wedding Video" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton component="a" href="#wedding-management">
              <ListItemText primary="Wedding Management" />
            </ListItemButton>
          </ListItem>

        </List>
      </nav>
    </Box>
  );
}
